import { deburr } from 'lodash-es';

import { stripHtmlTags } from '@change-corgi/core/html';

export function truncate(string: string, width = 210, ellipsis = ' …'): string {
	if (width > string.length) {
		return string;
	}
	let tempStringTruncated = string.slice(0, width - ellipsis.length); // Truncated + ellipsis;
	const lastword = tempStringTruncated.lastIndexOf(' '); // get last word to avoid "break last word"

	tempStringTruncated = tempStringTruncated.slice(0, lastword); // Remove the last 'break' word

	return tempStringTruncated + ellipsis;
}

const ZERO_WIDTH_JOINER = String.fromCodePoint(0x200d);
const VARIATION_SELECTOR_16 = String.fromCodePoint(0xfe0f);
const COMBINING_ENCLOSING_KEYCAP = String.fromCodePoint(0x20e3);

// \p{Extended_Pictographic} matches emoji base characters. \p{Emoji_Modifier} matches skin-tone
// modifiers (e.g. the modifier in a waving hand with a skin tone). \p{Regional_Indicator} matches
// the letter-pair components of flag emoji (e.g. the two letters making up a country flag). The
// zero-width joiner combines emoji into sequences (e.g. family emoji). Variation selector-16
// forces emoji presentation (e.g. a heart glyph rendered as an emoji rather than plain text). The
// combining enclosing keycap turns a digit/#/* into a keycap emoji (e.g. the "1" in a numbered
// keycap) — without stripping it too, a keycap sequence would leave a boxed digit behind.
const EMOJI_PATTERN = new RegExp(
	`\\p{Extended_Pictographic}|\\p{Emoji_Modifier}|\\p{Regional_Indicator}|${ZERO_WIDTH_JOINER}|${VARIATION_SELECTOR_16}|${COMBINING_ENCLOSING_KEYCAP}`,
	'gu',
);

export function stripEmojis(string: string): string {
	return string.replace(EMOJI_PATTERN, '');
}

export function removeDiacritics(string: string): string {
	return deburr(string.normalize('NFD'));
}

/**
 * Normalizes a string by stripping HTML tags, removing diacritics, trimming whitespace, replacing
 * multiple spaces with a single space, and converting to lowercase.
 */
export function normalize(string: string): string {
	const strippedString = stripHtmlTags(string);
	return removeDiacritics(strippedString).trim().replace(/\s+/g, ' ').toLowerCase();
}
